<template>
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.phone.imei.label') }}</label>
      <input
        v-model="value.imei"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.phone.imei.placeholder')"
        maxlength="20"
        @blur="$emit('lookup-key', value.imei)"
      >
      <small class="text-muted">{{ $t('involvedForm.phone.imei.hint') }}</small>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.phone.number.label') }}</label>
      <input
        v-model="value.number"
        v-mask="['(##) ####-####', '(##) #####-####']"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.phone.number.placeholder')"
      >
    </div>

    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.phone.carrier.label') }}</label>
      <input
        v-model="value.carrier"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.phone.carrier.placeholder')"
      >
    </div>
    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.phone.owner.label') }}</label>
      <input
        v-model="value.owner_name"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.phone.owner.placeholder')"
      >
    </div>

    <div class="col-12 form-group">
      <label>{{ $t('involvedForm.phone.observation.label') }}</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedPhoneForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
